import { render, staticRenderFns } from "./TopUpCredit.vue?vue&type=template&id=d5b67252&scoped=true"
import script from "./TopUpCredit.vue?vue&type=script&lang=js"
export * from "./TopUpCredit.vue?vue&type=script&lang=js"
import style0 from "./TopUpCredit.vue?vue&type=style&index=0&id=d5b67252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b67252",
  null
  
)

export default component.exports